import { isString } from '@helpers/utils.js'
import { computed, ref } from 'vue'

const state = ref({})
const usernameState = ref({})
export default function (id, param, userParam) {
  if (!id) {
    throw new Error('useSearch requires id')
  }

  if (param) {
    setSearch(param)
  }

  if (userParam) {
    setUserSearch(userParam)
  }

  function setSearch(value) {
    state.value[id] = isString(value) && value.trim()
  }

  function setUserSearch(value) {
    usernameState.value[id] = isString(value) && value.trim()
  }

  const search = computed(() => state.value?.[id])
  const searchUserName = computed(() => usernameState.value?.[id])

  function clearSearch() {
    delete state.value[id]
  }

  function clearUserSearch() {
    delete usernameState.value[id]
  }

  function _match(haystack, needle) {
    return haystack.toLowerCase().includes(needle.toLowerCase())
  }

  function inMemorySearch(data, isGuides = false) {
    if (!search.value && !searchUserName.value) return data
    return data.filter((item) => {
      if (
        searchUserName.value &&
        !_match(item.submitted_by.username, searchUserName.value)
      ) {
        return false
      }

      if (search.value) {
        if (
          isGuides &&
          !_match(item.name, search.value) &&
          !_match(item.summary, search.value) &&
          !_match(item.description, search.value)
        ) {
          return false
        } else if (!isGuides && !_match(item.name, search.value)) {
          return false
        }
      }

      return true
    })
  }

  const getSearch = computed(() => {
    return {
      _q: search.value || null,
      'submitted_by_display_name-lk': searchUserName.value
        ? `${searchUserName.value}*`
        : null,
    }
  })

  return {
    clearUserSearch,
    searchUserName,
    inMemorySearch,
    setUserSearch,
    clearSearch,
    getSearch,
    setSearch,
    search,
  }
}
